var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "323.892px",
    height: "240px",
    viewBox: "0 0 323.892 240",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "30.113%",
    y1: "0%",
    x2: "30.113%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-0, 0)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.006,146.192 C212.758,148.864 210.33,148.82 208.883,148.443 L208.937,147.059 C208.937,147.059 214.916,144.326 214.764,144.9 C214.707,145.115 214.821,145.633 215.006,146.192 L215.006,146.192 Z M231.393,149.217 C227.575,151.423 225.335,148.837 224.815,148.105 C225.135,147.265 225.616,145.901 225.518,145.513 C225.374,144.936 231.345,147.668 231.345,147.668 L231.393,149.217 Z M227.303,127.204 C227.303,127.204 230.935,125.111 231.728,126.053 C232.52,126.995 227.303,127.204 227.303,127.204 Z M229.497,128.355 C229.497,128.355 228.899,128.654 230.218,129.036 C231.536,129.419 229.497,128.355 229.497,128.355 Z M207.532,122.599 C207.409,122.635 210.554,124.722 213.394,122.994 C213.382,122.994 208.24,122.384 207.532,122.599 Z M213.239,126.591 C213.239,126.591 212.378,128.283 210.614,128.534 C208.85,128.785 213.239,126.591 213.239,126.591 Z M224.785,130.262 C224.785,130.262 228.923,136.84 228.131,138.391 C227.338,139.943 224.785,130.262 224.785,130.262 Z M216.62,156.416 C216.62,156.784 216.62,157.128 216.584,157.412 C216.477,158.742 213.203,158.24 213.203,158.24 C210.213,158.656 209.137,157.221 208.781,155.848 C208.669037,155.402407 208.613933,154.944433 208.617,154.485 C208.614964,154.211047 208.633012,153.937314 208.671,153.666 L208.671,153.394 C209.314955,153.199306 210.013657,153.341753 210.53,153.773 C211.861,154.853 213.625,154.025 213.625,154.025 C213.625,154.025 214.919,154.132 215.418,154.563 C215.699,154.805 216.163,154.222 216.516,153.666 C216.537,154.025 216.57,154.673 216.59,155.367 C216.614,155.723 216.62,156.081 216.62,156.416 L216.62,156.416 Z",
    id: "Shape",
    fill: "#FF4842",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.37,156.339 C211.37,156.339 210.473,157.218 208.781,155.86 C208.669037,155.414407 208.613933,154.956433 208.617,154.497 C209.481,155.155 211.083,156.339 211.37,156.339 L211.37,156.339 Z M216.62,156.416 C216.47287,156.530231 216.284827,156.578057 216.101,156.548 C215.917082,156.519077 215.753405,156.41515 215.649,156.261 C215.997,155.995 216.318,155.695 216.605,155.364 C216.614,155.723 216.62,156.081 216.62,156.416 L216.62,156.416 Z M223.637,157.032 C223.637,157.403 223.637,157.747 223.67,158.028 C223.778,159.361 227.052,158.856 227.052,158.856 C230.041,159.275 231.118,157.839 231.473,156.464 C231.649655,155.750525 231.68734,155.009718 231.584,154.282 L231.584,154.01 C230.938918,153.819027 230.241106,153.961063 229.722,154.389 C228.391,155.469 226.63,154.64 226.63,154.64 C226.63,154.64 225.336,154.751 224.836,155.182 C224.555,155.424 224.092,154.841 223.742,154.285 C223.708142,154.851612 223.682139,155.418667 223.664,155.986 C223.64,156.336 223.634,156.694 223.637,157.032 Z",
    id: "Shape",
    fill: "#FF4842",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.887,156.949 C228.887,156.949 229.784,157.828 231.474,156.47 C231.586,156.026 231.643,155.569 231.641,155.11 C230.774,155.765 229.171,156.949 228.887,156.949 L228.887,156.949 Z M223.637,157.032 C223.783698,157.146588 223.971454,157.19498 224.155264,157.165578 C224.339074,157.136176 224.502366,157.03163 224.606,156.877 C224.256892,156.611836 223.936181,156.311233 223.649,155.98 C223.64,156.336 223.635,156.694 223.637,157.032 L223.637,157.032 Z M241.614,46.269 C241.677,46.131 241.737,45.994 241.794,45.859 C241.851,45.725 241.871,45.65 241.904,45.542 C241.794,45.779 241.698,46.022 241.614,46.269 L241.614,46.269 Z",
    id: "Shape",
    fill: "#FF4842",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.592,219.461 C78.8678817,218.588318 78.5360882,217.455444 78.675,216.33 L91.871,108.351 L92.965,99.381 C93.2194176,97.3175945 94.9640343,95.7624984 97.043,95.746 L135.697,95.489 C136.80902,95.4821621 137.871415,95.0277085 138.644369,94.2282236 C139.417324,93.4287387 139.835679,92.3516176 139.805,91.24 L139.79,90.831 C139.752341,89.7099905 140.171146,88.6216754 140.950579,87.8150992 C141.730012,87.0085231 142.803358,86.552 143.925,86.552 L184.544,86.552 C185.736041,86.552 186.870122,87.0662879 187.655223,87.9632716 C188.440323,88.8602552 188.800016,90.0524786 188.642,91.234 C188.486953,92.3977382 188.833656,93.572548 189.595702,94.4656393 C190.357748,95.3587306 191.463362,95.8859856 192.637,95.916 L231.647,96.912 C232.847344,96.9410334 233.975629,97.4910064 234.73795,98.4186567 C235.500271,99.346307 235.821149,100.559788 235.617,101.743 L216.115,215.652 L215.747,217.804 C215.656213,218.35407 215.452613,218.879412 215.149,219.347 L79.592,219.461 L79.592,219.461 Z",
    id: "Path",
    fill: "#8F3800"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    transform: "translate(184.6777, 102.0596) rotate(34.64) translate(-184.6777, -102.0596)",
    points: "173.256992 63.2963624 196.098492 63.2963624 196.098492 140.822862 173.256992 140.822862"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFC107",
    transform: "translate(200.6871, 77.9207) rotate(34.804) translate(-200.6871, -77.9207)",
    points: "192.624215 69.8578295 208.749915 69.8578295 208.749915 85.9835295 192.624215 85.9835295"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFC107",
    opacity: 0.5,
    transform: "translate(190.3495, 93.8865) rotate(34.64) translate(-190.3495, -93.8865)",
    points: "182.275777 85.8127542 198.423277 85.8127542 198.423277 101.960254 182.275777 101.960254"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFC107",
    opacity: 0.3,
    transform: "translate(179.2653, 109.9261) rotate(34.64) translate(-179.2653, -109.9261)",
    points: "171.1916 101.852323 187.3391 101.852323 187.3391 117.999823 171.1916 117.999823"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    transform: "translate(170.8933, 99.951) rotate(16.29) translate(-170.8933, -99.951)",
    points: "159.472536 61.3342959 182.314036 61.3342959 182.314036 138.567796 159.472536 138.567796"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FF4842",
    transform: "translate(179.1269, 71.8353) rotate(16.29) translate(-179.1269, -71.8353)",
    points: "171.053109 63.7615255 187.200609 63.7615255 187.200609 79.9090255 171.053109 79.9090255"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FF4842",
    opacity: 0.5,
    transform: "translate(173.6579, 90.5473) rotate(16.29) translate(-173.6579, -90.5473)",
    points: "165.584109 82.4735255 181.731609 82.4735255 181.731609 98.6210245 165.584109 98.6210245"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FF4842",
    opacity: 0.3,
    transform: "translate(168.1899, 109.2563) rotate(16.29) translate(-168.1899, -109.2563)",
    points: "160.116109 101.182526 176.263609 101.182526 176.263609 117.330026 160.116109 117.330026"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    transform: "translate(163.5199, 100.2583) rotate(4.6) translate(-163.5199, -100.2583)",
    points: "152.099169 61.6415364 174.940669 61.6415364 174.940669 138.875036 152.099169 138.875036"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#1890FF",
    transform: "translate(165.8743, 71.0593) rotate(4.6) translate(-165.8743, -71.0593)",
    points: "157.800548 62.9855206 173.948048 62.9855206 173.948048 79.1330206 157.800548 79.1330206"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#1890FF",
    opacity: 0.5,
    transform: "translate(164.3082, 90.4873) rotate(4.6) translate(-164.3082, -90.4873)",
    points: "156.234467 82.4135163 172.381967 82.4135163 172.381967 98.5610163 156.234467 98.5610163"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#1890FF",
    opacity: 0.3,
    transform: "translate(162.7462, 109.9203) rotate(4.6) translate(-162.7462, -109.9203)",
    points: "154.672467 101.846517 170.819967 101.846517 170.819967 117.994017 154.672467 117.994017"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    transform: "translate(158.1574, 102.0016) rotate(-2.61) translate(-158.1574, -102.0016)",
    points: "146.736639 63.3848529 169.578139 63.3848529 169.578139 140.618353 146.736639 140.618353"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    transform: "translate(156.825, 72.7337) rotate(-2.61) translate(-156.825, -72.7337)",
    points: "148.75127 64.6599668 164.89877 64.6599668 164.89877 80.8074668 148.75127 80.8074668"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    opacity: 0.5,
    transform: "translate(158.3895, 91.5631) rotate(-2.862) translate(-158.3895, -91.5631)",
    points: "150.305605 83.4792513 166.473305 83.4792513 166.473305 99.6469513 150.305605 99.6469513"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    opacity: 0.3,
    transform: "translate(158.599, 111.6827) rotate(-2.61) translate(-158.599, -111.6827)",
    points: "150.525269 103.608967 166.672769 103.608967 166.672769 119.756467 150.525269 119.756467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.679,165.726 L134.385,173.577 L104.724,185.043 C103.603,182.95 101.953,180.122 99.911,176.746 C92.885,165.104 81.261,146.996 70.91,131.081 C59.25,113.143 49.214,98.006 49.214,98.006 L56.479,95.913 L115.825,78.683 L154.679,165.726 L154.679,165.726 Z",
    id: "Path",
    fill: "#F4F6F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.679,165.726 L134.385,173.577 C123.047897,175.938929 111.478695,177.002112 99.901,176.746 C92.875,165.104 81.251,146.996 70.901,131.081 L56.481,95.901 L115.824,78.683 L154.679,165.726 Z",
    id: "Path",
    fill: "#000000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.777,160.841 C169.777,160.841 138.251,179.491 91.181,175.273 L53.656,83.787 L71.64,80.696 L133.808,70.019 L169.087,159.062 L169.777,160.841 L169.777,160.841 Z",
    id: "Path",
    fill: "#8F3800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.075,159.074 C161.651,159.439 153.062,159.403 144.421,158.372 C135.07,157.271 125.664,155.005 117.601,150.849 C110.859,147.378 105.095,143.602 100.069,139.073 C86.995,127.314 78.905,110.494 71.64,80.708 L133.808,70.031 L169.075,159.074 Z",
    id: "Path",
    fill: "#FF4842",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.203,153.959 C192.203,153.959 168.964,158.509 145.309,155.708 C135.958,154.608 126.552,152.341 118.489,148.186 C111.747,144.715 105.986,140.939 100.957,136.409 C84.776,121.852 76.232,99.543 67.421,54.491 C67.421,54.491 106.054,63.816 144.257,43.39 C144.245,43.405 157.122,123.763 192.203,153.959 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.405,71.03 C87.405,71.03 118.821,69.254 127.592,62.482 L128.923,66.758 C128.923,66.758 108.165,75.915 87.405,76.026 L87.405,71.03 L87.405,71.03 Z M87.405,92.137 C87.405,92.137 117.822,90.472 140.804,79.371 L141.581,81.147 C141.581,81.147 123.344,91.794 87.405,94.58 L87.405,92.137 L87.405,92.137 Z M89.853,100.362 C89.853,100.362 120.271,98.697 143.25,87.596 L144.027,89.372 C144.027,89.372 125.79,100.015 89.853,102.805 L89.853,100.362 L89.853,100.362 Z M92.299,108.599 C92.299,108.599 122.716,106.933 145.698,95.833 L146.472,97.608 C146.472,97.608 128.235,108.255 92.299,111.041 L92.299,108.599 Z M94.748,116.835 C94.748,116.835 125.165,115.17 148.144,104.069 L148.921,105.845 C148.921,105.845 130.684,116.492 94.748,119.278 L94.748,116.835 Z M97.193,125.075 C97.193,125.075 127.61,123.41 150.592,112.309 L151.366,114.085 C151.366,114.085 133.129,124.728 97.193,127.518 L97.193,125.075 Z",
    id: "Shape",
    fill: "#000000",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.069,227.344 C311.069,227.344 298.428,226.582 299.917,235.441 C299.917,235.441 299.618,237.004 301.041,237.716 C301.041,237.716 301.062,237.058 302.336,237.282 C302.79,237.359 303.252,237.381 303.711,237.348 C304.330997,237.306903 304.920271,237.063041 305.388,236.654 C305.856,236.245 308.943,235.186 310.324,229.38 C310.324,229.38 311.347,228.113 311.305,227.787 L309.173,228.684 C309.173,228.684 309.903,230.224 309.329,231.5 C309.329,231.5 309.26,228.741 308.85,228.809 C308.767,228.809 307.741,229.342 307.741,229.342 C307.741,229.342 308.994,232.032 308.04,233.97 C308.04,233.97 308.399,230.666 307.341,229.536 L305.846,230.412 C305.846,230.412 307.311,233.18 306.318,235.441 C306.318,235.441 306.572,231.976 305.529,230.624 L304.168,231.686 C304.168,231.686 305.547,234.415 304.707,236.29 C304.707,236.29 304.596,232.254 303.872,231.949 C303.872,231.949 302.677,232.998 302.503,233.443 C302.503,233.443 303.445,235.423 302.859,236.469 C302.859,236.469 302.5,233.778 302.207,233.778 C302.207,233.778 301.011,235.572 300.898,236.768 C300.898,236.768 300.949,234.95 301.92,233.596 C301.235462,233.727028 300.60381,234.05432 300.102,234.538 C300.102,234.538 300.288,233.276 302.213,233.168 C302.213,233.168 303.194,231.817 303.454,231.733 C303.454,231.733 301.54,231.575 300.38,232.089 C300.38,232.089 301.403,230.893 303.807,231.44 L305.149,230.346 C305.149,230.346 302.629,229.999 301.561,230.382 C301.561,230.382 302.79,229.33 305.511,230.083 L306.973,229.21 C306.973,229.21 304.826,228.747 303.547,228.911 C303.547,228.911 304.895,228.182 307.403,228.971 L308.447,228.501 C308.447,228.501 306.874,228.202 306.414,228.143 C305.953,228.083 305.926,227.969 305.926,227.969 C306.923068,227.80101 307.94724,227.914961 308.883,228.298 C308.883,228.298 311.105,227.485 311.069,227.344 L311.069,227.344 Z",
    id: "Path",
    fill: "#B54700"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#B54700",
    opacity: 0.1,
    cx: 302.363,
    cy: 238.487,
    rx: 8.945,
    ry: 1.513
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.956,198.102 C316.956,198.102 309.831,197.672 310.677,202.667 C310.587789,203.186117 310.842375,203.703761 311.308,203.95 C311.308,203.95 311.323,203.579 312.041,203.705 C312.296,203.747 312.556,203.759 312.815,203.741 C313.164,203.718 313.496,203.582 313.76,203.352 C314.024,203.122 315.763,202.524 316.543,199.25 C316.543,199.25 317.12,198.536 317.096,198.353 L315.9,198.864 C315.9,198.864 316.31,199.734 315.987,200.455 C315.987,200.455 315.948,198.897 315.718,198.933 C315.67,198.933 315.093,199.232 315.093,199.232 C315.093,199.232 315.799,200.727 315.266,201.842 C315.266,201.842 315.47,199.98 314.872,199.34 L314.026,199.836 C314.026,199.836 314.851,201.397 314.292,202.67 C314.292,202.67 314.435,200.715 313.846,199.956 L313.081,200.554 C313.081,200.554 313.855,202.093 313.38,203.149 C313.38,203.149 313.317,200.874 312.911,200.703 C312.620164,200.948923 312.359962,201.228934 312.136,201.537 C312.136,201.537 312.668,202.655 312.34,203.244 C312.34,203.244 312.136,201.729 311.972,201.723 C311.972,201.723 311.302,202.724 311.233,203.412 C311.26595,202.77398 311.464837,202.155604 311.81,201.618 C311.423591,201.691082 311.067167,201.876075 310.785,202.15 C310.785,202.15 310.889,201.439 311.981,201.379 C311.981,201.379 312.534,200.616 312.68,200.569 C312.68,200.569 311.601,200.479 310.946,200.769 C310.946,200.769 311.523,200.099 312.878,200.404 L313.637,199.785 C313.637,199.785 312.214,199.591 311.613,199.806 C311.613,199.806 312.307,199.208 313.84,199.645 L314.666,199.151 C314.030926,199.012087 313.380394,198.956951 312.731,198.987 C312.731,198.987 313.494,198.574 314.905,199.02 L315.503,198.757 C315.503,198.757 314.606,198.58 314.355,198.554 C314.103,198.527 314.08,198.455 314.08,198.455 C314.642403,198.360975 315.219869,198.425023 315.748,198.64 C315.748,198.64 316.98,198.18 316.956,198.102 L316.956,198.102 Z",
    id: "Path",
    fill: "#B54700"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#B54700",
    opacity: 0.1,
    cx: 312.052,
    cy: 204.383,
    rx: 5.044,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.896,202.437 C274.896,202.437 266.292,201.917 267.308,207.947 C267.200329,208.574043 267.508259,209.199185 268.071,209.496 C268.071,209.496 268.071,209.047 268.968,209.197 C269.277,209.249 269.591,209.264 269.903,209.242 C270.325347,209.214307 270.72676,209.048048 271.045,208.769 C271.363,208.49 273.464,207.771 274.406,203.818 C274.406,203.818 275.103,202.957 275.073,202.733 L273.605,203.355 C273.605,203.355 274.101,204.401 273.709,205.271 C273.709,205.271 273.661,203.394 273.383,203.436 C273.327,203.436 272.63,203.8 272.63,203.8 C272.63,203.8 273.482,205.624 272.839,206.952 C272.839,206.952 273.084,204.703 272.364,203.932 L271.341,204.53 C271.341,204.53 272.337,206.416 271.661,207.953 C271.661,207.953 271.835,205.594 271.126,204.664 L270.199,205.388 C270.199,205.388 271.138,207.245 270.564,208.521 C270.564,208.521 270.492,205.774 269.999,205.567 C269.999,205.567 269.189,206.282 269.066,206.575 C269.066,206.575 269.706,207.923 269.308,208.635 C269.308,208.635 269.063,206.805 268.863,206.796 C268.863,206.796 268.059,208.01 267.966,208.838 C268.006,208.07 268.246,207.326 268.663,206.679 C268.197368,206.768113 267.76803,206.991646 267.428,207.322 C267.428,207.322 267.553,206.464 268.863,206.389 C268.863,206.389 269.53,205.469 269.709,205.415 C269.709,205.415 268.406,205.304 267.616,205.654 C267.616,205.654 268.31,204.847 269.945,205.214 L270.86,204.467 C270.86,204.467 269.147,204.234 268.418,204.491 C268.418,204.491 269.255,203.776 271.108,204.3 L272.104,203.702 C272.104,203.702 270.642,203.388 269.769,203.501 C269.769,203.501 270.69,203.005 272.394,203.543 L273.105,203.223 C273.105,203.223 272.035,203.014 271.721,202.981 C271.407,202.948 271.392,202.862 271.392,202.862 C272.070156,202.746688 272.767043,202.823235 273.404,203.083 C273.404,203.083 274.923,202.53 274.896,202.437 L274.896,202.437 Z",
    id: "Path",
    fill: "#B54700"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#B54700",
    opacity: 0.1,
    cx: 268.97,
    cy: 210.022,
    rx: 6.09,
    ry: 1.028
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(251.4397, 54.868) rotate(-71.99) translate(-251.4397, -54.868)",
    x: 225.926691,
    y: 9.211951,
    width: 51.026,
    height: 91.312,
    rx: 4.737
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#000000",
    opacity: 0.2,
    cx: 225.613,
    cy: 43.507,
    r: 9.376
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    opacity: 0.2,
    transform: "translate(267.8666, 46.9133) rotate(-71.99) translate(-267.8666, -46.9133)",
    points: "266.582478 26.4889995 269.150648 26.4889995 269.150648 67.3375996 266.582478 67.3375996"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    opacity: 0.2,
    transform: "translate(256.3118, 50.0414) rotate(-71.99) translate(-256.3118, -50.0414)",
    points: "255.027731 39.6371791 257.595901 39.6371791 257.595901 60.4456789 255.027731 60.4456789"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    opacity: 0.2,
    transform: "translate(260.3927, 58.2587) rotate(-71.99) translate(-260.3927, -58.2587)",
    points: "259.108634 41.4310947 261.676804 41.4310947 261.676804 75.0863947 259.108634 75.0863947"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    opacity: 0.2,
    transform: "translate(261.7896, 65.5993) rotate(-71.99) translate(-261.7896, -65.5993)",
    points: "260.505478 45.1750002 263.073648 45.1750002 263.073648 86.0236012 260.505478 86.0236012"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    opacity: 0.5,
    transform: "translate(272.5441, 80.3003) rotate(-71.99) translate(-272.5441, -80.3003)",
    points: "270.061175 74.6482016 275.027105 74.6482016 275.027105 85.9523016 270.061175 85.9523016"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(238.6999, 153.6391) rotate(-57.265) translate(-238.6999, -153.6391)",
    x: 213.54988,
    y: 114.486612,
    width: 50.3,
    height: 78.305,
    rx: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#DFE3E8",
    transform: "translate(207.154, 145.563) rotate(-57.57) translate(-207.154, -145.563)",
    points: "200.038431 143.888756 214.269531 143.888756 214.269531 147.237246 200.038431 147.237246"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#DFE3E8",
    transform: "translate(220.6352, 140.7369) rotate(-57.57) translate(-220.6352, -140.7369)",
    points: "205.007922 139.201638 236.262522 139.201638 236.262522 142.272088 205.007922 142.272088"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#DFE3E8",
    transform: "translate(226.1712, 144.2509) rotate(-57.57) translate(-226.1712, -144.2509)",
    points: "210.543922 142.715638 241.798522 142.715638 241.798522 145.786088 210.543922 145.786088"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#DFE3E8",
    transform: "translate(231.7062, 147.7709) rotate(-57.57) translate(-231.7062, -147.7709)",
    points: "216.078923 146.235637 247.333523 146.235637 247.333523 149.306087 216.078923 149.306087"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#DFE3E8",
    transform: "translate(237.4852, 152.9398) rotate(-57.265) translate(-237.4852, -152.9398)",
    points: "221.879848 151.40671 253.090648 151.40671 253.090648 154.47285 221.879848 154.47285"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F4F6F8",
    transform: "translate(242.7772, 154.8039) rotate(-57.57) translate(-242.7772, -154.8039)",
    points: "227.149923 153.268637 258.404523 153.268637 258.404523 156.339087 227.149923 156.339087"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F4F6F8",
    transform: "translate(248.3132, 158.3179) rotate(-57.57) translate(-248.3132, -158.3179)",
    points: "232.685922 156.782638 263.940522 156.782638 263.940522 159.853088 232.685922 159.853088"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#DFE3E8",
    transform: "translate(267.4644, 154.4541) rotate(-57.57) translate(-267.4644, -154.4541)",
    points: "263.4178 150.407528 271.51098 150.407528 271.51098 158.500708 263.4178 158.500708"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.277,108.759848 L145.51,109.253 C143.796686,109.271082 142.417,110.664591 142.416,112.378 L142.416,116.16 C142.414887,117.8562 141.061686,119.242233 139.366,119.284 L106.342,120.076 C104.901512,120.112523 103.622919,119.159052 103.247,117.768 L101.696,112.067 C101.323869,110.691377 100.067966,109.741942 98.643,109.759 L54.53,110.234 C53.615176,110.243046 52.7502618,110.652521 52.1634424,111.354395 C51.5766229,112.05627 51.3268428,112.980042 51.48,113.882 L69.227,218.331 C69.4820815,219.829821 70.7776423,220.928369 72.298,220.935 L211.661,221.533011 C212.594747,221.535439 213.480792,221.120732 214.077079,220.402169 C214.673366,219.683607 214.917578,218.736285 214.743,217.819 L194.377,111.298 C194.093222,109.813754 192.788058,108.745204 191.277,108.759848 L191.277,108.759848 Z",
    id: "Path",
    fill: "#FF6500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.277,108.759848 L145.51,109.253 C143.796686,109.271082 142.417,110.664591 142.416,112.378 L142.416,116.16 C142.414887,117.8562 141.061686,119.242233 139.366,119.284 L106.342,120.076 C104.901512,120.112523 103.622919,119.159052 103.247,117.768 L101.696,112.067 C101.323869,110.691377 100.067966,109.741942 98.643,109.759 L54.53,110.234 C53.615176,110.243046 52.7502618,110.652521 52.1634424,111.354395 C51.5766229,112.05627 51.3268428,112.980042 51.48,113.882 L69.227,218.331 C69.4820815,219.829821 70.7776423,220.928369 72.298,220.935 L211.661,221.533011 C212.594747,221.535439 213.480792,221.120732 214.077079,220.402169 C214.673366,219.683607 214.917578,218.736285 214.743,217.819 L194.377,111.298 C194.093222,109.813754 192.788058,108.745204 191.277,108.759848 L191.277,108.759848 Z",
    id: "Path",
    fill: "#000000",
    opacity: 0.243
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.277,108.759848 L145.51,109.253 C143.796686,109.271082 142.417,110.664591 142.416,112.378 L142.416,116.16 C142.414887,117.8562 141.061686,119.242233 139.366,119.284 L106.342,120.076 C104.901512,120.112523 103.622919,119.159052 103.247,117.768 L101.696,112.067 C101.323869,110.691377 100.067966,109.741942 98.643,109.759 L54.53,110.234 C53.615176,110.243046 52.7502618,110.652521 52.1634424,111.354395 C51.5766229,112.05627 51.3268428,112.980042 51.48,113.882 L69.227,218.331 C69.4820815,219.829821 70.7776423,220.928369 72.298,220.935 L211.661,221.533011 C212.594747,221.535439 213.480792,221.120732 214.077079,220.402169 C214.673366,219.683607 214.917578,218.736285 214.743,217.819 L194.377,111.298 C194.093222,109.813754 192.788058,108.745204 191.277,108.759848 L191.277,108.759848 Z",
    id: "Path",
    fill: "url(#linearGradient-1)",
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#B14600",
    opacity: 0.1,
    cx: 41.593,
    cy: 198.664,
    rx: 4.846,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#B14600",
    opacity: 0.1,
    cx: 23.03,
    cy: 200.545,
    rx: 4.846,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#B14600",
    opacity: 0.1,
    cx: 30.459,
    cy: 205.905,
    rx: 3.444,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#B14600",
    opacity: 0.1,
    cx: 11.193,
    cy: 205.433,
    rx: 3.444,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.925,200.398 C22.925,200.398 29.721,178.119 21.861,169.194 C15.98,162.518 9.304,163.317 6.314,164.142 C4.74932432,164.559914 3.44661244,165.642949 2.75,167.105 C1.704,169.359 1.892,173.018 9.271,177.291 C21.621,184.442 22.39,194.251 22.39,194.251 L22.925,200.398 Z",
    id: "Path",
    fill: "#B14600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.382,167.302 C7.382,167.302 27.413,173.58 22.928,200.398 M19.083,169.547 C19.083,169.547 16.323,171.407 17.203,174.202 M9.39,171.203 C9.39,171.203 11.077,169.487 13.131,170.435 M17.31,179.832 C17.31,179.832 20.273,178.337 21.038,180.211 M24.638,182.962 C24.638,182.962 22.414,182.786 22.375,183.859",
    id: "Shape",
    stroke: "#000000",
    strokeWidth: 0.5,
    fill: "#B14600",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2,200.575 C23.2,200.575 15.239,184.382 13.053,184.729 C12.016,184.899 11.537,185.925 11.319,186.947 C11.0507848,188.273856 11.2024758,189.651307 11.753,190.888 C12.883,193.489 15.918,198.407 23.2,200.575 L23.2,200.575 Z",
    id: "Path",
    fill: "#B14600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.113,187.808 C13.113,187.808 21.466,199.923 23.081,200.455",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.5,
    fill: "#B14600",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.344,
    y1: 189.701,
    x2: 14.293,
    y2: 189.701,
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.5,
    fill: "#B14600",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.68,
    y1: 194.132,
    x2: 17.738,
    y2: 194.263,
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.5,
    fill: "#B14600",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.542,
    y1: 190.586,
    x2: 16.21,
    y2: 192.179,
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.5,
    fill: "#B14600",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.792,
    y1: 195.432,
    x2: 19.732,
    y2: 196.879,
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.5,
    fill: "#B14600",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.964,200.575 C22.964,200.575 30.923,184.382 33.108,184.729 C34.149,184.899 34.627,185.925 34.842,186.947 C35.1106625,188.273747 34.959317,189.651235 34.409,190.888 C33.279,193.489 30.241,198.407 22.964,200.575 L22.964,200.575 Z",
    id: "Path",
    fill: "#B14600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.051,187.808 C33.051,187.808 24.68,199.923 23.081,200.455",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.5,
    fill: "#B14600",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33.82,
    y1: 189.701,
    x2: 31.871,
    y2: 189.701,
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.5,
    fill: "#B14600",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.485,
    y1: 194.132,
    x2: 28.426,
    y2: 194.263,
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.5,
    fill: "#B14600",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.622,
    y1: 190.586,
    x2: 29.954,
    y2: 192.179,
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.5,
    fill: "#B14600",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26.372,
    y1: 195.432,
    x2: 26.432,
    y2: 196.879,
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.5,
    fill: "#B14600",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.295,204.357 C9.07811548,204.180003 8.92042298,203.941022 8.843,203.672 C8.76699528,203.393641 8.90024717,203.100655 9.16,202.975 C9.46,202.865 9.758,203.065 9.997,203.274 C10.237,203.484 10.509,203.705 10.807,203.654 C10.4843606,203.361528 10.3392741,202.920951 10.425,202.494 C10.4372719,202.407071 10.4736457,202.325316 10.53,202.258 C10.691,202.084 10.984,202.159 11.178,202.297 C11.776,202.727 11.965,203.561 11.968,204.315 C11.998,204.038 11.998,203.76 11.968,203.484 C11.9517361,203.201245 12.0768776,202.928857 12.302,202.757 C12.4477813,202.677543 12.6120404,202.638204 12.778,202.643 C13.0558184,202.60374 13.3372266,202.684454 13.552,202.865 C13.7614731,203.149848 13.7490824,203.540982 13.522,203.812 C13.293,204.069 13.022,204.286 12.721,204.452 C12.4925772,204.58989 12.2975651,204.776705 12.15,204.999 C12.1318407,205.029015 12.1177189,205.061293 12.108,205.095 L10.368,205.095 C9.97863215,204.89861 9.61767989,204.65035 9.295,204.357 L9.295,204.357 Z M39.626,197.833 C39.408658,197.657673 39.2507926,197.419477 39.174,197.151 C39.0980769,196.873708 39.229869,196.581583 39.488,196.455 C39.787,196.344 40.086,196.544 40.325,196.754 C40.564,196.963 40.834,197.19 41.142,197.145 C40.8187536,196.854093 40.6721682,196.414717 40.756,195.988 C40.7689518,195.900892 40.8060153,195.819144 40.863,195.752 C41.025,195.579 41.318,195.653 41.512,195.788 C42.125,196.221 42.299,197.056 42.302,197.809 C42.3310024,197.531756 42.3310024,197.252244 42.302,196.975 C42.2741933,196.69537 42.3860572,196.420013 42.601,196.239 C42.7471486,196.161852 42.9108161,196.12395 43.076,196.129 C43.3531549,196.089914 43.633985,196.169011 43.85,196.347 C44.0603667,196.633451 44.0467167,197.02682 43.817,197.298 C43.5896559,197.555503 43.3197221,197.771991 43.019,197.938 C42.7901138,198.074 42.5949192,198.259965 42.448,198.482 C42.4305402,198.513073 42.4164599,198.545927 42.406,198.58 L40.705,198.58 C40.3127,198.381792 39.9496121,198.130424 39.626,197.833 L39.626,197.833 Z M29.518,204.357 C29.3014564,204.179114 29.1430112,203.940576 29.063,203.672 C28.9874184,203.393675 29.120551,203.100951 29.38,202.975 C29.679,202.865 29.978,203.065 30.217,203.274 C30.456,203.484 30.722,203.711 31.033,203.669 C30.7109823,203.376045 30.5650531,202.936362 30.648,202.509 C30.6609518,202.421892 30.6980153,202.340144 30.755,202.273 C30.917,202.099 31.21,202.174 31.404,202.312 C32.017,202.742 32.187,203.576 32.193,204.33 C32.223,204.053 32.223,203.775 32.193,203.498 C32.1696625,203.216146 32.287213,202.940988 32.507,202.763 C32.6526413,202.683179 32.8170005,202.643816 32.983,202.649 C33.2608184,202.60974 33.5422266,202.690454 33.757,202.871 C33.9667274,203.15619 33.9530705,203.548101 33.724,203.818 C33.4962205,204.075046 33.2263707,204.291467 32.926,204.458 C32.6974346,204.595703 32.5023851,204.782555 32.355,205.005 C32.3369614,205.035077 32.3228467,205.067339 32.313,205.101 L30.579,205.101 C30.194,204.901 29.837,204.651 29.518,204.357 L29.518,204.357 Z",
    id: "Shape",
    fill: "#B14600"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#AD4400",
    opacity: 0.1,
    cx: 6.467,
    cy: 27.003,
    r: 6.467
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#000000",
    opacity: 0.1,
    cx: 317.425,
    cy: 78.681,
    r: 6.467
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#BA4900",
    opacity: 0.1,
    cx: 201.178,
    cy: 6.467,
    r: 6.467
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#AD4400",
    opacity: 0.1,
    cx: 19.4,
    cy: 62.68,
    r: 10.838
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.029,149.911 C120.054,149.911 113.589,156.376 113.589,164.351 C113.589,172.326 120.054,178.791 128.029,178.791 C136.004,178.791 142.469,172.326 142.469,164.351 C142.469,156.376 136.004,149.911 128.029,149.911 Z",
    id: "Path",
    fill: "#000000",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.029,151.59 C135.076,151.59 140.79,157.304 140.79,164.351 C140.79,171.399 135.076,177.112 128.029,177.112 C120.981,177.112 115.268,171.399 115.268,164.351 C115.274,157.306 120.984,151.597 128.029,151.59",
    id: "Path",
    fill: "#FF6500",
    opacity: 0.467587426
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.058,165.406 L121.359,164.725 C121.209351,164.588394 121.124091,164.395123 121.124091,164.1925 C121.124091,163.989877 121.209351,163.796606 121.359,163.66 L127.486,157.676 C127.628756,157.527579 127.82607,157.4441 128.032,157.444993 C128.238,157.444993 128.436,157.528 128.577,157.676 L134.704,163.654 C134.850359,163.792448 134.933281,163.985033 134.933281,164.1865 C134.933281,164.387967 134.850359,164.580552 134.704,164.719 L134.005,165.401 C133.860778,165.546528 133.664386,165.628395 133.4595,165.628395 C133.254614,165.628395 133.058222,165.546528 132.914,165.401 L129.292,161.674 L129.292,170.517 C129.293024,170.713834 129.21397,170.902624 129.073,171.04 C128.930399,171.179646 128.738589,171.257592 128.539,171.257056 L127.53,171.257056 C127.11616,171.262003 126.776488,170.930834 126.771,170.517 L126.771,161.685 L123.149,165.411 C123.004112,165.555869 122.807344,165.636837 122.602458,165.635898 C122.397571,165.634959 122.201554,165.552191 122.058,165.406 L122.058,165.406 Z",
    id: "Path",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImages);
export default __webpack_public_path__ + "static/media/images.a67d807d7238a6d4b302de9ca3947dcf.svg";
export { ForwardRef as ReactComponent };